// Source - https://stackoverflow.com/a
// Posted by Mihailo, modified by community. See post 'Timeline' for change history
// Retrieved 2026-01-08, License - CC BY-SA 3.0

import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { AuthService } from './auth.service';
import { Observable } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    req = req.clone({
      setHeaders: {
        'Content-Type' : 'application/json; charset=utf-8',
        'Accept'       : 'application/json',
        'Authorization': `Bearer ${AuthService.getAuth()}`,
      },
    });

    return next.handle(req);
  }
}
